import setupAdobe from "../analytics/setupAdobe";
import setupOptimizely from "./features/setupOptimizely";

const setupAnalytics = async store => {
  try {
    await setupOptimizely(store);
  } finally {
    setupAdobe(store);
  }
};

export default setupAnalytics;
